"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Object = _interopRequireDefault(require("../Object.js"));

var _State = _interopRequireDefault(require("./State.js"));

var _util = require("../util.js");

var _proj = require("../proj.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/source/Source
 */


/**
 * A function that takes a {@link module:ol/PluggableMap~FrameState} and returns a string or
 * an array of strings representing source attributions.
 *
 * @typedef {function(import("../PluggableMap.js").FrameState): (string|Array<string>)} Attribution
 */

/**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * * a simple string (e.g. `'© Acme Inc.'`)
 * * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */

/**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./State.js").default} [state='ready'] State.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */

/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */
var Source =
/** @class */
function (_super) {
  __extends(Source, _super);
  /**
   * @param {Options} options Source options.
   */


  function Source(options) {
    var _this = _super.call(this) || this;
    /**
     * @protected
     * @type {import("../proj/Projection.js").default}
     */


    _this.projection = (0, _proj.get)(options.projection);
    /**
     * @private
     * @type {?Attribution}
     */

    _this.attributions_ = adaptAttributions(options.attributions);
    /**
     * @private
     * @type {boolean}
     */

    _this.attributionsCollapsible_ = options.attributionsCollapsible !== undefined ? options.attributionsCollapsible : true;
    /**
     * This source is currently loading data. Sources that defer loading to the
     * map's tile queue never set this to `true`.
     * @type {boolean}
     */

    _this.loading = false;
    /**
     * @private
     * @type {import("./State.js").default}
     */

    _this.state_ = options.state !== undefined ? options.state : _State["default"].READY;
    /**
     * @private
     * @type {boolean}
     */

    _this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
    /**
     * @private
     * @type {boolean}
     */

    _this.interpolate_ = !!options.interpolate;
    /**
     * @protected
     * @type {function(import("../View.js").ViewOptions):void}
     */

    _this.viewResolver = null;
    /**
     * @protected
     * @type {function(Error):void}
     */

    _this.viewRejector = null;
    var self = _this;
    /**
     * @private
     * @type {Promise<import("../View.js").ViewOptions>}
     */

    _this.viewPromise_ = new Promise(function (resolve, reject) {
      self.viewResolver = resolve;
      self.viewRejector = reject;
    });
    return _this;
  }
  /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   * @api
   */


  Source.prototype.getAttributions = function () {
    return this.attributions_;
  };
  /**
   * @return {boolean} Attributions are collapsible.
   * @api
   */


  Source.prototype.getAttributionsCollapsible = function () {
    return this.attributionsCollapsible_;
  };
  /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   */


  Source.prototype.getProjection = function () {
    return this.projection;
  };
  /**
   * @abstract
   * @return {Array<number>|null} Resolutions.
   */


  Source.prototype.getResolutions = function () {
    return (0, _util["abstract"])();
  };
  /**
   * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
   */


  Source.prototype.getView = function () {
    return this.viewPromise_;
  };
  /**
   * Get the state of the source, see {@link module:ol/source/State~State} for possible states.
   * @return {import("./State.js").default} State.
   * @api
   */


  Source.prototype.getState = function () {
    return this.state_;
  };
  /**
   * @return {boolean|undefined} Wrap X.
   */


  Source.prototype.getWrapX = function () {
    return this.wrapX_;
  };
  /**
   * @return {boolean} Use linear interpolation when resampling.
   */


  Source.prototype.getInterpolate = function () {
    return this.interpolate_;
  };
  /**
   * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
   * @api
   */


  Source.prototype.refresh = function () {
    this.changed();
  };
  /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
   *     or `undefined`.
   * @api
   */


  Source.prototype.setAttributions = function (attributions) {
    this.attributions_ = adaptAttributions(attributions);
    this.changed();
  };
  /**
   * Set the state of the source.
   * @param {import("./State.js").default} state State.
   */


  Source.prototype.setState = function (state) {
    this.state_ = state;
    this.changed();
  };

  return Source;
}(_Object["default"]);
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {Attribution|null} An attribution function (or null).
 */


function adaptAttributions(attributionLike) {
  if (!attributionLike) {
    return null;
  }

  if (Array.isArray(attributionLike)) {
    return function (frameState) {
      return attributionLike;
    };
  }

  if (typeof attributionLike === 'function') {
    return attributionLike;
  }

  return function (frameState) {
    return [attributionLike];
  };
}

var _default = Source;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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